import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import GestionCategoriesDepenses from "./GestionCategoriesDepenses";
import ExpenseCategoriesMobile from "../mobile/depenses/ExpenseCategoriesMobile";

export default function ResponsiveGestionCategoriesDepenses(props) {
  return useIsMobile() ? <ExpenseCategoriesMobile {...props} /> : <GestionCategoriesDepenses {...props} />;
}
